import React from 'react'
import get from 'lodash/get';
import {Button} from '../components/button'

// import marked from 'marked';

import Layout from '../components/layout'
import Contact from '../components/contact'
import HeroImg from '../components/images/kontakt-hero';

import contentfulClient from '../util/contentful-client';

export default class KontaktPage extends React.Component {
  state = {
    headline: '',
    contacts: [],
    linktext: '',
    url: ''
  }

  componentDidMount() {
    contentfulClient.getEntries({
      'content_type': 'kontakta-oss',
      limit: 1
    }).then(entries => {
      const fields = get(entries, 'items[0].fields', {});

      const headline = fields.headline || '';
      const linktext = fields.linktext || '';
      const url = fields.url || '';
      const contacts = (fields.kontaktpersoner || []).map(({ fields, sys }) => ({
        id: sys.id,
        name: fields.name,
        area: fields.area,
        department: fields.department || '',
        phone: fields.phone,
        email: fields.email,
      })).map(({ id, name, area, department, phone, email }) => (
        <Contact
          key={id}
          name={name}
          title={area}
          department={department}
          phone={phone}
          email={email} />
      ));

      this.setState({ headline, linktext, url, contacts });
    })
  }

  get getContacts() {
    return this.state.contacts;
  }

  get getLink() {
    if (!this.state.linktext || !this.state.url) return null;

    return (
      <Button href={this.state.url} external rounded target="_blank" rel="noopener noreferrer">
        {this.state.linktext}
      </Button>
    )
  }

  get getHeadline() {
    return this.state.headline;
  }

  render(){
    return(
      <Layout {...this.props}>
        <div className="contact-wrapper">
          <div className="contact-bg">
            <HeroImg />
          </div>
          
          <div className="row row-small mb-2">
            <h1 className="is-white">{this.getHeadline}</h1>
          </div>
          <div className="row row-medium contact-grid">
            {this.getContacts}
          </div>
          <div className="row row-small">
          {this.getLink}
          </div>
        </div>
      </Layout>
    );
  }
}
